import "@fontsource/roboto-mono";

import { Shell } from './shell';

function App() {
  return (
    <>
      <Shell />
    </>
  );
}

export default App;
